import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import useContactFormStyles from '../../assets/css/_contactForm';

export default function ContactForm({ prefilledService = null }) {
  const classes = useContactFormStyles();
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [body, setBody] = useState('');
  const [service, setService] = useState(prefilledService || '');
  const [errors, setErrors] = useState({});

  // Update service if prefilledService prop changes
  useEffect(() => {
    if (prefilledService) {
      setService(prefilledService);
    }
  }, [prefilledService]);

  const validateForm = () => {
    const newErrors = {};
    
    if (!email || email.trim() === '') {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = 'Please enter a valid email';
    }
    
    if (!name || name.trim() === '') {
      newErrors.name = 'Full name is required';
    }
    
    if (!body || body.trim() === '') {
      newErrors.body = 'Message is required';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const openWindow = () => {
    if (!validateForm()) {
      return;
    }
    
    const serviceInfo = service ? `\nService of Interest: ${service}` : '';
    const fullBody = `Hello Cybros, I'm writing this to get the quote or information about my project.${serviceInfo}
    ${body}
    Thanks,
    Name: ${name}
    Email: ${email}
    `;
    window.open(`mailto:info@cybros.dev?subject=Quotation for my project&body=${fullBody}`);
  };

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            value={email}
            label="Email Address"
            variant="outlined"
            placeholder="Email Address"
            fullWidth
            error={!!errors.email}
            helperText={errors.email}
            InputProps={{
              className: classes.input,
            }}
            className={classes.rootTextField}
            onChange={(e) => {
              setEmail(e.target.value);
              if (errors.email) {
                setErrors({ ...errors, email: '' });
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={name}
            label="Full Name"
            variant="outlined"
            fullWidth
            error={!!errors.name}
            helperText={errors.name}
            InputProps={{
              className: classes.input,
            }}
            className={classes.rootTextField}
            onChange={(e) => {
              setName(e.target.value);
              if (errors.name) {
                setErrors({ ...errors, name: '' });
              }
            }}
          />
        </Grid>
        {prefilledService && (
          <Grid item xs={12}>
            <TextField
              value={service}
              label="Service of Interest"
              variant="outlined"
              fullWidth
              disabled
              InputProps={{
                className: classes.input,
              }}
              className={classes.rootTextField}
            />
          </Grid>
        )}
        <Grid item xs={12}>
          <TextField
            value={body}
            label="Message"
            variant="outlined"
            multiline
            rows={4}
            fullWidth
            error={!!errors.body}
            helperText={errors.body}
            InputProps={{
              className: classes.input,
            }}
            className={classes.rootTextField}
            onChange={(e) => {
              setBody(e.target.value);
              if (errors.body) {
                setErrors({ ...errors, body: '' });
              }
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <Button 
            variant="contained" 
            fullWidth 
            size="large" 
            className={classes.rootButton} 
            onClick={openWindow}
            disabled={!!errors.email || !!errors.name || !!errors.body || !email || !name || !body}
          >
            Send
          </Button>
        </Grid>
      </Grid>
    </form>
  );
}
